import { AccountType, type CurrentUserResponse, type UserProfile } from './types';

export const getAccountInformation = ({ account }: CurrentUserResponse) => {
  if (account) {
    const { parentAccountId, tradingName, type } = account;
    const isDivision: boolean = type === AccountType.DIVISION || false;

    return {
      division: isDivision && parentAccountId ? { name: tradingName, parentAccountId } : null,
      isDivision,
      isParent: account?.type === AccountType.PARENT || false,
      registeredCompanyName: account?.tradingName || ''
    };
  }

  return {
    division: null,
    isDivision: false,
    isParent: false,
    registeredCompanyName: ''
  };
};

export const getUserInformation = ({ currentUserDetails }: CurrentUserResponse) => {
  if (!currentUserDetails) {
    throw new Error('currentUserDetails is required');
  }

  const { account, email, firstName, hasPlatformAccess, id, lastName, name, phoneNumber } = currentUserDetails;

  return {
    accountUuid: account?.parentAccountId || account?.id || '',
    firstName: firstName || '',
    hasPlatformAccess,
    lastName: lastName || '',
    name: name || '',
    email: email || '',
    organizationalRole: account.organizationalRole,
    phoneNumber: phoneNumber || '',
    uuid: id || '',
    role: null,
    isSingleSignOn: account.ssoDetails.enabled || false
  };
};

export const prepareUserProfile = (values: CurrentUserResponse): UserProfile => {
  return {
    isAdmin: values.authorizationRole.isAdmin ?? false,
    ...getUserInformation(values),
    ...getAccountInformation(values)
  };
};

export const saveUserData = (userProfile: UserProfile) => {
  const { division, isAdmin, isParent, registeredCompanyName, uuid } = userProfile;

  window.localStorage.setItem('accountName', registeredCompanyName);
  window.localStorage.setItem('isAdmin', `${isAdmin}`);
  window.localStorage.setItem('isDivision', `${!!division}`);
  window.localStorage.setItem('isParent', `${!!isParent}`);
  window.localStorage.setItem('userId', uuid);
};
